import { FC } from 'react';
import DiagonalDivider from 'assets/images/diagonal-divider.png';
import clsx from 'clsx';
import { motion } from 'framer-motion';
interface ProgressIndicatorProps {
  percentage: number;
  barClassName: string;
}

const ProgressIndicator: FC<ProgressIndicatorProps> = ({
  percentage,
  barClassName,
}) => {
  return (
    <div className="relative h-2.5 flex-1 rounded-sm">
      <div className="absolute h-full w-full overflow-hidden rounded-sm bg-neutral-700 bg-opacity-50" />
      <motion.div
        className="h-full w-full rounded-sm bg-auto bg-repeat opacity-[8%]"
        style={{
          backgroundImage: `url(${DiagonalDivider})`,
        }}
        animate={{ backgroundPositionX: ['0%', '100%'] }}
        transition={{
          repeat: Infinity,
          ease: 'linear',
          duration: 6,
        }}
      />
      <div
        className={clsx(
          'absolute left-0 top-0 h-2.5 rounded-sm shadow-elevation1',
          barClassName,
        )}
        style={{ width: `${percentage}%` }}
      />
    </div>
  );
};

export default ProgressIndicator;
